"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ALL_CLOSED_WON_VALUE = void 0;
var ALL_CLOSED_WON_VALUE = '__hs__CLOSEDWON';
exports.ALL_CLOSED_WON_VALUE = ALL_CLOSED_WON_VALUE;